import React from 'react';
import './HabitSchedulePreview.css';

const HabitSchedulePreview = ({ scheduleSummary, upcomingHabits }) => {
  const formatDate = (date) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    
    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return 'Tomorrow';
    } else {
      return date.toLocaleDateString('en-US', { 
        weekday: 'short', 
        month: 'short', 
        day: 'numeric' 
      });
    }
  };

  const getDaysUntil = (date) => {
    const today = new Date();
    const diffTime = date.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays < 7) return `In ${diffDays} days`;
    if (diffDays < 14) return 'Next week';
    if (diffDays < 30) return `In ${Math.ceil(diffDays / 7)} weeks`;
    return `In ${Math.ceil(diffDays / 30)} months`;
  };

  return (
    <div className="habit-schedule-preview">
      <div className="schedule-header">
        <h3>Your Habit Schedule</h3>
        <p>We've spread out your weekly and monthly habits to avoid overwhelming days</p>
      </div>

      <div className="schedule-summary">
        <div className="daily-summary">
          <div className="summary-icon">📅</div>
          <div className="summary-content">
            <h4>Daily Habits</h4>
            <p>{scheduleSummary.daily} habits every day</p>
          </div>
        </div>

        {scheduleSummary.weekly.length > 0 && (
          <div className="weekly-summary">
            <div className="summary-icon">📊</div>
            <div className="summary-content">
              <h4>Weekly Habits</h4>
              <div className="weekly-list">
                {scheduleSummary.weekly.map((habit, index) => (
                  <div key={index} className="weekly-item">
                    <span className="habit-name">{habit.name}</span>
                    <span className="habit-day">{habit.day}s</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {scheduleSummary.monthly.length > 0 && (
          <div className="monthly-summary">
            <div className="summary-icon">🗓️</div>
            <div className="summary-content">
              <h4>Monthly Treatments</h4>
              <div className="monthly-list">
                {scheduleSummary.monthly.map((habit, index) => (
                  <div key={index} className="monthly-item">
                    <span className="habit-name">{habit.name}</span>
                    <span className="habit-timing">{getDaysUntil(habit.date)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {upcomingHabits.length > 0 && (
        <div className="upcoming-preview">
          <h4>Coming Up This Week</h4>
          <div className="upcoming-list">
            {upcomingHabits.slice(0, 3).map((day, index) => (
              <div key={index} className="upcoming-day">
                <div className="upcoming-date">
                  {formatDate(day.date)}
                </div>
                <div className="upcoming-habits">
                  {day.habits.map((habit, habitIndex) => (
                    <span key={habitIndex} className="upcoming-habit">
                      {habit.icon} {habit.name}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="schedule-note">
        <p>💡 <strong>Smart Scheduling:</strong> Your weekly habits are spread across different days, and monthly treatments are scheduled weeks apart to keep your routine manageable.</p>
      </div>
    </div>
  );
};

export default HabitSchedulePreview;
